import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
@Component({
    selector: 'app-disinfection-current-schedule-tile',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './current-schedule-tile.component.html',
    styleUrl: './current-schedule-tile.component.scss'
})
export class CurrentScheduleTileComponent {
    getStatusClass(eventStatus: string): string {
        switch (eventStatus?.toLowerCase()) {
            case 'scheduled':
                return 'scheduled-tile';

            case 'complete':
                return 'complete-tile';

            case 'overdue':
                return 'overdue-tile';

            default:
                return 'gray-tile';
        }
    }

    getStatusBadgeClass(eventStatus: string): string {
        switch (eventStatus?.toLowerCase()) {
            case 'scheduled':
                return 'scheduled-badge';

            case 'complete':
                return 'complete-badge';

            case 'overdue':
                return 'overdue-badge';

            default:
                return 'gray-badge';
        }
    }
    @Input() eventName!: string;
    @Input() eventPlace!: string;
    @Input() dueDate!: string;
    @Input() lastDate!: string;
    @Input() assignedTo!: string;
    @Input() eventStatus!: string;
}
